import { useQuery } from '@tanstack/react-query';

import { GetProfileTutorialStatusApiResponse } from '@/entities/profile';
import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';
import { LogLevel, logger } from '@/shared/utils';

const useProfileTutorialStatus = () => {
  return useQuery({
    queryKey: ['getProfileTutorialStatusApi'],
    queryFn: async () => {
      try {
        const { data } = await clientAxios.get<
          ApiResponse<GetProfileTutorialStatusApiResponse>
        >('/getProfileTutorialStatusApi/');

        const { is_scraped, is_highlighted, is_subscribed_to_author } =
          data.data;

        return {
          isScraped: is_scraped,
          isHighlighted: is_highlighted,
          isSubscribedToAuthor: is_subscribed_to_author,
        };
      } catch (error) {
        logger(LogLevel.ERROR, error, {
          message: 'getProfileTutorialStatusApi error',
        });
      }
    },
  });
};

export default useProfileTutorialStatus;
